<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-select
          v-model="inputPathname"
          :items="categoryOptions"
          label="Select Category"
          item-title="name"
          item-value="pathname"
          clearable
          class="mb-4"
        ></v-select>
      </v-col>
    </v-row>


    <v-card v-if="category" class="pa-4">
      <v-card-title class="text-h4 mb-4">{{ category.name }}</v-card-title>
      
      <v-card-text>
        <div class="text-body-1"><strong>Meta Title:</strong> {{ category.metaTitle }}</div>
        <div class="text-body-1"><strong>Meta Description:</strong> {{ category.metaDescription }}</div>

        <v-divider class="my-4"></v-divider>

        <h2 class="text-h5 mb-2">Images</h2>
        <v-row>
          <v-col v-for="(image, index) in category.images" :key="index" cols="12" sm="6" md="4">
            <v-img :src="image.src" :alt="image.alt" height="200" contain></v-img>
            <div class="text-caption mt-2">Type: {{ image.type }}</div>
          </v-col>
        </v-row>

        <v-divider class="my-4"></v-divider>

        <h2 class="text-h5 mb-2">Description</h2>
        <div class="text-body-1" >{{category.description.descriptionHtml}}</div>

        <v-divider class="my-4"></v-divider>

        <h2 class="text-h5 mb-2">Associated Product Paths</h2>
        <v-list>
          <v-list-item v-for="(productPath, index) in category.productsPaths" :key="index">
            {{ productPath }}
          </v-list-item>
        </v-list>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" @click="openPage">
          Open Category
        </v-btn>
        <v-btn color="secondary" @click="copySource">
          Copy Source
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-alert v-else-if="inputPathname && !category" type="warning" class="mt-4">
      No category found for pathname: "{{ inputPathname }}"
    </v-alert>
  </v-container>
</template>

<script lang="ts" setup>
import { ref, computed } from 'vue';
import { useCategoriesStore } from '@/store/categoriesStore';
import { useUrlSourcesStore } from '@/store/urlSourcesStore';
import  UrlSourceTypes  from '@/enums/UrlSourceTypes';
import { useActiveUrlStore } from '@/store/activeUrlStore';

const categoriesStore = useCategoriesStore();
const urlSourcesStore = useUrlSourcesStore ();
const activeUrlStore = useActiveUrlStore();

const url = activeUrlStore.activeUrl;
const inputPathname = ref<string>('');

const categoryOptions = computed(() => 
urlSourcesStore.getAllPathnamesByType(UrlSourceTypes.CATEGORY)
    .map(path => ({
      pathname: path,
      name: formatCategoryName(path)
    }))
);

const category = computed(() =>
  inputPathname.value ? categoriesStore.getCategoryByPathname(inputPathname.value) : undefined
);

function formatCategoryName(path: string): string {
  return path
    .replace('/category/', '')
    .replace(/-/g, ' ')
    .replace(/\b\w/g, char => char.toUpperCase());
}
function openPage() {
  if (url && category.value) {
    window.open(`${url}${category.value.pathname}`, '_blank');
  }
}

// Copies the URL source to the clipboard
async function copySource() {
  const source = urlSourcesStore.getSourceByPathname(inputPathname.value);
  if (source) {
    try {
      await navigator.clipboard.writeText(source);
      console.log('Source copied to clipboard');
    } catch (err) {
      console.error('Failed to copy source to clipboard:', err);
    }
  }
}
</script>